import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import { Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import moment from "moment";

const AddReadingModal = ({
    modal,
    toggle,
    GetExpenseHeadList,
    modalData,
    setModalData,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        expenseHeadType: [],
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
    } = useForm();

    // useEffect(() => {
    //     if (modalData) {
    //         reset({
    //             name: modalData?.name,
    //         });
    //     }
    // }, [modalData, modal]);

    const closeHandler = () => {
        // setModalData({});
        toggle();
        reset();
    };
    // console.log(state);

    const onSubmit = (data) => {
        const options = {
            method: "POST",
            data: { ...data, machineryId: modalData },
        };
        let API = apiUrl?.add_machinery_reading;
        setIsLoading(true);
        callApi(API, options).then((response) => {
            setIsLoading(false);
            if (response?.status === true) {
                toast.success(response?.message);
                closeHandler();
                GetExpenseHeadList(1);
            } else {
                toast.error(response?.message);
            }
        });

    };

    return (
        <Modal
            className="modal-dialog modal-dialog-centered modal-md reading-modal"
            isOpen={modal}
            toggle={closeHandler}
        >
            <ModalHeader toggle={closeHandler}>
                {" "}
                <h3>{"Add"} Machinery Reading</h3>
            </ModalHeader>
            <ModalBody>
                <form
                    id="loginForm"
                    className="tooltip-end-bottom"
                    onSubmit={handleSubmit(onSubmit)}
                >
                    <div className="mb-3 filled form-group tooltip-end-top">
                        <div>
                            <label htmlFor="selectcat" className="form-label">
                                Date
                            </label>
                            <Controller
                                name="date"
                                control={control}
                                rules={{
                                    required: "This field is required",
                                    validate: (value) => {
                                        const checkDate = moment(value).startOf('day');
                                        const today = moment().startOf('day');
                                        if (checkDate.isAfter(today)) {
                                            return "Future dates are not allowed";
                                        }
                                        return true;
                                    }
                                }}
                                defaultValue={moment().format("YYYY-MM-DD")}
                                render={({ field }) => (
                                    <DatePicker size="sm"
                                        {...field}
                                        format="dd/MM/yyyy"
                                        oneTap
                                        placeholder="dd/mm/yyyy"
                                        style={{ width: "100%" }}
                                        value={field.value ? new Date(field.value) : null}
                                        onChange={(date) => {
                                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                        }}
                                        shouldDisableDate={(date) => date > new Date(moment().endOf('day'))}
                                        container={() => document.querySelector('.reading-modal .modal-content') || document.body}
                                        cleanable={false}
                                    />
                                )}
                            />
                            <ErrorMessage message={errors?.date?.message} />
                        </div>
                        <div>
                            <label htmlFor="selectcat" className="form-label mt-2">
                                Reading
                            </label>
                            <input
                                className="form-control ps-2"
                                placeholder="Enter Reading..."
                                name="name"
                                type="text"
                                {...register("reading", {
                                    required: "This field is required",
                                })}
                                onChange={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '')
                                }}
                            />
                            <ErrorMessage message={errors?.reading?.message} />
                        </div>
                        <div>
                            <label htmlFor="selectcat" className="form-label mt-2">
                                Fuel Consumption
                            </label>
                            <input
                                className="form-control ps-2"
                                placeholder="Enter Fuel Consumption..."
                                name="name"
                                type="text"
                                {...register("fuelConsumption", {
                                    required: "This field is required",
                                })}
                                onChange={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9]/g, '')
                                }}
                            />
                            <ErrorMessage message={errors?.fuelConsumption?.message} />
                        </div>

                    </div>
                    <div className="modal-footer p-3">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-dismiss="modal"
                            onClick={closeHandler}
                        >
                            Cancel
                        </button>
                        <button className="btn btn-primary" type="submit">
                            {isLoading ? <Spinner /> : "Add"}
                        </button>
                    </div>
                </form>
            </ModalBody>
        </Modal>
    );
};

export default AddReadingModal;
